import { defineAction } from 'redux-define'

const CANCELLED  = 'CANCELLED'
const ERROR      = 'ERROR'
const PENDING    = 'PENDING'
const UPDATE    = 'UPDATE'
const SUCCESS    = 'SUCCESS'

//Fetch dashboard
export const FETCH_RECENT           = defineAction('FETCH_RECENT', [PENDING, ERROR, SUCCESS])

// Fetch all available deposits
export const FETCH_DEPOSITS         = defineAction('FETCH_DEPOSITS', [PENDING, ERROR, SUCCESS])

// Fetch info about a single deposit
export const FETCH_DEPOSIT          = defineAction('FETCH_DEPOSIT', [PENDING, ERROR, SUCCESS])
export const UPDATE_DEPOSIT         = defineAction('UPDATE_DEPOSIT', [PENDING, ERROR, SUCCESS])
export const DELETE_DEPOSIT         = defineAction('DELETE_DEPOSIT', [PENDING, ERROR, SUCCESS])

export const FETCH_VERIFICATIONS    = defineAction('FETCH_VERIFICATIONS', [PENDING, ERROR, SUCCESS])

// Fetching a (running) verification
export const FETCH_VERIFICATION     = defineAction('FETCH_VERIFICATION', [PENDING, ERROR, UPDATE, SUCCESS])

// Running a verification
export const START_VERIFICATION     = defineAction('START_VERIFICATION', [PENDING, ERROR, SUCCESS])
export const DELETE_VERIFICATION     = defineAction('DELETE_VERIFICATION', [PENDING, ERROR, SUCCESS])

// Salesfore related
export const SALESFORCE_PUSH        = defineAction('SALESFORCE_PUSH', [PENDING, ERROR, SUCCESS])

// System status
export const FETCH_STATUS           = defineAction('FETCH_STATUS', [PENDING, ERROR, UPDATE, SUCCESS])

// Authentication
export const AUTH_LOGIN             = defineAction('AUTH_LOGIN', [PENDING, ERROR, SUCCESS])
export const AUTH_LOGOUT            = defineAction('AUTH_LOGOUT', [PENDING, ERROR, SUCCESS])

// Settings
export const SETTINGS_FETCH         = defineAction('SETTINGS_FETCH', [PENDING, ERROR, SUCCESS])
export const SETTINGS_UPDATE        = defineAction('SETTINGS_UPDATE', [PENDING, ERROR, SUCCESS])

// Modals
export const OPEN_MODAL             = defineAction('OPEN_MODAL', [PENDING, ERROR, SUCCESS])
export const CLOSE_MODAL            = defineAction('CLOSE_MODAL', [PENDING, ERROR, SUCCESS])



// WEBPACK FOOTER //
// ./src/actions/index.js